import { IGatsbyImageData } from 'gatsby-plugin-image'
import { addDomainOnUrl } from '../../Utils/functionnals'
import { getMediaUrl } from '../../Utils/medias'
import { Media } from '../../types/Medias'
import { SubscriptionType } from '../../types/firm/Subscription'
import { Tool } from '../../types/tool'
import { FirmTeaserProps } from '../firms'
import { formatNbOffices } from '../firms/format'

export type GraphqlToolFirmType = {
  id: number
  name: string | null
  slug: string | null
  totalEmployees: string | null
  logo: Media | null
  header: Media | null
  offices:
  | {
    postalCode: string | null
    city: string | null
    offers:
    | {
      id: string | null
    }[]
    | null
  }[]
  | null
  subscription: {
    name: SubscriptionType | null
  } | null
}

export function graphqlToolFirmMapper(
  graphqlToolFirm: GraphqlToolFirmType,
): FirmTeaserProps | null {
  if (!graphqlToolFirm?.name || !graphqlToolFirm?.slug) {
    return null
  }
  const address =
    graphqlToolFirm.offices && graphqlToolFirm.offices.length > 0
      ? graphqlToolFirm.offices[0]
      : null
  const cityCut =
    address?.city && address?.city.length > 18
      ? `${address?.city.slice(0, 17)}...`
      : address?.city

  const offices = graphqlToolFirm.offices ? [...graphqlToolFirm.offices] : []
  const nbOfficesToDisplay = formatNbOffices(
    offices ? offices.length : 0,
  )
  const logo = graphqlToolFirm.logo?.url
    ? addDomainOnUrl(graphqlToolFirm.logo.url)
    : null
  const nbTotalOffers = offices
    ? offices.reduce(
      (acc, office) => acc + (office.offers ? office.offers.length : 0),
      0,
    )
    : 0

  return {
    id: graphqlToolFirm.id,
    name: graphqlToolFirm.name,
    city: `${cityCut} ${address?.postalCode ? `(${address.postalCode.slice(0, 2)})` : ''
      }`.trim(),
    header: getMediaUrl(graphqlToolFirm.header) || null,
    logo,
    totalEmployees:
      graphqlToolFirm.totalEmployees !== null
        ? graphqlToolFirm.totalEmployees
        : '',
    url: `/cabinets/${graphqlToolFirm.slug}`,
    nbTotalOffers,
    nbOffices: nbOfficesToDisplay,
    subscriptionType: graphqlToolFirm.subscription?.name || undefined,
  }
}

export type ToolTeaserType = {
  id: number
  name: string
  logo: string | null
  url: string
  header: IGatsbyImageData | string | null
  nbTotalFirms: number
}

export function graphqlToolTeaserMapper(
  tools: Tool[],
): ToolTeaserType[] {
  if (!tools || tools.length === 0) {
    return []
  }
  return [...tools]
    .filter(Boolean)
    .map((tool) => ({
      id: tool.id,
      name: tool.name || '',
      logo: addDomainOnUrl(tool.logo?.url) || null,
      header: (tool.header?.formats?.thumbnail?.url || tool.header?.url) || null,
      url: tool.permalink,
      permalink: tool.permalink,
      nbTotalFirms: tool.firms?.length || 0,
    }))
}
